module.exports = "/dist/img/noshi_uchi.e44f4044.png";